import PropTypes from "prop-types"
import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import TabNavigation from "components/tablink/tablink"
import { Card, CardBody } from "reactstrap"

class ClientSellerMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    handleSelectChange = (e) => {
        this.props.history.push(e.target.value);
    };
    render() {
        const { isResponsive } = this.props;
        const { id, clientId } = this.props.match.params;
        const navItems = [
            { id: "property", label: "Add Property", link: `/clients/seller/property/${id}/${clientId}` },
            { id: "showings", label: "Showings", link: `/clients/seller/showings/${id}/${clientId}` },
            { id: "open-house", label: "Open House", link: `/clients/seller/open-house/${id}/${clientId}` },
            { id: "questions", label: "Seller Preferences", link: `/clients/seller/questions/${id}/${clientId}` },
        ];
        return (
            <React.Fragment>
                {isResponsive ? (
                    <Card className="mb-3">
                        <CardBody>
                            <h6>Select Menu</h6>
                            <select
                                className="form-control mb-3"
                                value={window.location.pathname}
                                onChange={this.handleSelectChange}
                            >
                                {navItems.map((item) => (
                                    <option key={item.id} value={item.link}>
                                        {item.label}
                                    </option>
                                ))}
                            </select>
                        </CardBody>
                    </Card>
                ):(
                      <TabNavigation navItems={navItems} />

                )}
              
              

            </React.Fragment>
        )
    }
}
ClientSellerMenu.propTypes = {
    match: PropTypes.object,
    isResponsive: PropTypes.object,
    history:PropTypes.object
}
export default withRouter(ClientSellerMenu)
